import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import SlotChip from "./slot_chip";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  box-sizing: border-box;
`;

const LabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 5px 10px;
  border: 0.3px solid rgba(98, 100, 105, 0.2);
  background: #e7e6e6;
  margin-top: 5px;
  margin-right: 5px;
`;

const Label = styled.span`
  color: #0f0f0f;
  white-space: nowrap;
`;

const SlotWrapper = styled.div`
  margin-top: 5px;
  margin-right: 5px;
`;

class SlotCapacities extends React.Component {
  static propTypes = {
    slots: PropTypes.array,
    getLabel: PropTypes.func,
    fillColor: PropTypes.string,
    fillTextColor: PropTypes.string,
    forceDisable: PropTypes.bool  // Force the chips to be disabled when we are not showing an option category.
  };

  render = () => {
    return (
      <Container>
        <LabelWrapper>
          <Label>{this.props.getLabel('options_screen.slot_consumed')}</Label>
        </LabelWrapper>
        {this.props.slots.map((slot, idx) => (
          <SlotWrapper key={idx}>
            <SlotChip
              label={slot.label}
              filled={slot.filled}
              disabled={!slot.visible || this.props.forceDisable}
              fillColor={this.props.fillColor}
              fillTextColor={this.props.fillTextColor}
            ></SlotChip>
          </SlotWrapper>
        ))}
      </Container>
    );
  };
}

export default SlotCapacities;
